import { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const storedToken = localStorage.getItem("access_token");
  const accessToken = storedToken ? JSON.parse(storedToken) : null;
  const [token, setToken] = useState(accessToken || "");

  const login = (tokenVal) => {
    setToken(tokenVal);
    localStorage.setItem("access_token", JSON.stringify(tokenVal));
  };

  const logout = () => {
    setToken("");
    localStorage.clear();
    navigate("/login");
  };
  const isAuthenticated = !!token;
  return (
    <AuthContext.Provider value={{ token, login, logout, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export default useAuth;
